import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { COMMON_IMPORTS } from '../../common-imports';
import { PanelModule } from 'primeng/panel';
import { PremyopeRiskScoreCategory } from '../../backend-response-models/calc-enums.helper';
import { TranslatePipe } from '../../languages/translate.pipe';
import Mustache from 'mustache';

@Component({
  selector: 'app-premyopia-eim-retest',
  standalone: true,
  imports: [...COMMON_IMPORTS, PanelModule],
  templateUrl: './premyopia-eim-retest.component.html',
  styleUrl: './premyopia-eim-retest.component.css',
})
export class PremyopiaEimRetestComponent implements OnInit, OnChanges {
  @Input({ required: true })
  premyopeRiskScoreCatagory!: PremyopeRiskScoreCategory;

  @Input({ required: true })
  retestMonths!: number;

  @Input()
  personalization?: string;

  private readonly predictionTemplateKeys: Record<PremyopeRiskScoreCategory, string> = {
    [PremyopeRiskScoreCategory.LITTLE_TO_NO_RISK]: 'LITTLE_NO_MYOPIA_RISK_SCORE_EIM_TEMPLATE',
    [PremyopeRiskScoreCategory.LITTLE_RISK]: 'LITTLE_MYOPIA_RISK_SCORE_EIM_TEMPLATE',
    [PremyopeRiskScoreCategory.MODERATE_RISK]: 'MODERATE_MYOPIA_RISK_SCORE_EIM_TEMPLATE',
    [PremyopeRiskScoreCategory.HIGH_RISK]: 'HIGH_MYOPIA_RISK_SCORE_EIM_TEMPLATE',
  };

  public eimText: string = 'NONE';
  public retestText: string = 'NONE';
  public retestString: string = 'NONE';

  public greyColor = '#808080';
  public whiteColor = '#FFFFFF';

  constructor(private translatePipe: TranslatePipe) {}

  ngOnInit() {
    this.setupComponent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setupComponent();
  }

  setupComponent() {
    const moustacheTemplate = this.translatePipe.transform(this.predictionTemplateKeys[this.premyopeRiskScoreCatagory]);
    const noNameName = this.translatePipe.transform('NO_NAME_NAME');
    const renderedTemplate = Mustache.render(moustacheTemplate, { PERSONALIZED_NAME: this.personalization ?? noNameName });

    this.eimText = renderedTemplate;
    this.retestText = this.getRetestPeriod(this.retestMonths);

    let LENGTH = this.retestMonths;
    let LENGTH_SUFFIX = this.translatePipe.transform('MONTHS');

    if (this.retestMonths == 12) {
      LENGTH = this.retestMonths / 12;
      LENGTH_SUFFIX = this.translatePipe.transform('YEAR');
    } else if (this.retestMonths == 24) {
      LENGTH = this.retestMonths / 12;
      LENGTH_SUFFIX = this.translatePipe.transform('YEARS');
    } else {
      LENGTH = this.retestMonths;
      LENGTH_SUFFIX = this.translatePipe.transform('MONTHS');
    }

    const moustacheTemplateRetest = this.translatePipe.transform('MYOPIA_SINGLE_VISIT_EIM_RETEST_BRIEF');
    const renderedRetestTemplate = Mustache.render(moustacheTemplateRetest, {
      LENGTH,
      LENGTH_SUFFIX,
    });

    this.retestString = renderedRetestTemplate;
  }

  getRetestPeriod(retestMonths: number): string {
    if (retestMonths <= 6) {
      return this.translatePipe.transform('RETEST_PERIOD_6_MONTHS');
    }

    if (retestMonths <= 12) {
      return this.translatePipe.transform('RETEST_PERIOD_12_MONTHS');
    }

    return this.translatePipe.transform('RETEST_PERIOD_24_MONTHS');
  }
}
